export const featureFlags = (config, _data, globalConfig) => {
  var _config$featureFlags;

  const localFeatureFlags = ((_config$featureFlags = config.featureFlags) === null || _config$featureFlags === void 0 ? void 0 : _config$featureFlags.reduce((acc, ffName) => {
    acc[ffName] = globalConfig.ffClient.getValue(ffName);
    return acc;
  }, {})) || null;

  if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) {
    return null;
  }

  return {
    featureFlags: { ...localFeatureFlags,
      ...globalConfig.featureFlags
    }
  };
};